import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigProvider } from '../../../app-config.provider';
import { AssetService } from '../services/asset.service';
import { AssetQuery } from '../../akita/asset-schema/asset.query';
import { AssetStore } from '../../akita/asset-schema/asset.store';

@Injectable({ providedIn: 'root' })
export class AssetFactory {

  constructor(private readonly appConfigProvider: AppConfigProvider, private readonly httpClient: HttpClient) {

  }

  public getAssetService(): AssetService {
    return new AssetService(this.httpClient, this.appConfigProvider);
  }

  public getAssetQuery(): AssetQuery {
    return new AssetQuery(this.getAssetStore());
}

  public getAssetStore(): AssetStore {
  return new AssetStore();
}


}
